(() => {
  const SELECTOR = '[data-lisado-buybox]';

  function initBuybox(box) {
    if (!box || box.dataset.lisadoReady === 'true') return;
    box.dataset.lisadoReady = 'true';

    const productInfo = box.closest('product-info');
    const quantityInput = box.querySelector('[data-lisado-quantity]');
    const tierInputs = [...box.querySelectorAll('[data-lisado-tier] input[type="radio"]')];
    const variantInput = box.querySelector('product-form input[name="id"]');
    const variantsScript = box.querySelector('[data-lisado-variants]');
    const sticky = productInfo?.querySelector('[data-lisado-sticky]');
    const stickySubmit = sticky?.querySelector('[data-sticky-submit]');
    const primarySubmit = box.querySelector('.product-form__submit');
    const claimReferenceLink = box.querySelector('[data-lisado-claim-reference-link]');
    const form = box.querySelector('product-form form');
    const daysPerUnit = Number(box.dataset.daysPerUnit || 1);
    const singular = box.dataset.unitSingular || 'Stück';
    const plural = box.dataset.unitPlural || 'Stück';
    const ctaTemplate = box.dataset.ctaTemplate || 'Jetzt {quantity} {unit} sichern';
    const currency = box.dataset.currency || 'EUR';
    const locale = box.dataset.locale || 'de-DE';
    let variants = [];

    try {
      variants = JSON.parse(variantsScript?.textContent || '[]');
    } catch (error) {
      console.error('Lisado: Variantendaten konnten nicht gelesen werden.', error);
    }

    const money = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const formatMoney = (cents) => money.format(Number(cents || 0) / 100);
    const selectedVariant = () => {
      const id = Number(variantInput?.value || variants[0]?.id || 0);
      return variants.find((variant) => Number(variant.id) === id) || variants[0] || null;
    };

    const calculate = (basePrice, quantity, discount) => {
      const raw = basePrice * quantity;
      // Shopify truncates the percentage discount to full cents per item.
      // Calculate in the same order so the product card matches cart/checkout.
      const savingPerUnit = Math.floor(basePrice * discount / 100);
      const unit = basePrice - savingPerUnit;
      const saving = savingPerUnit * quantity;
      const total = unit * quantity;
      return {
        raw,
        saving,
        total,
        unit,
        day: Math.round(total / Math.max(1, quantity * daysPerUnit)),
      };
    };

    function tierUnavailable(input, variant) {
      if (!variant?.available) return true;
      if (variant.inventory_management !== 'shopify' || variant.inventory_policy === 'continue') return false;
      return Number(variant.inventory_quantity || 0) < Number(input.value || 1);
    }

    function refreshTierCards(variant) {
      tierInputs.forEach((input) => {
        const quantity = Number(input.value || 1);
        const discount = Number(input.dataset.discount || 0);
        const values = calculate(Number(variant?.price || 0), quantity, discount);
        const card = input.closest('[data-lisado-tier]');
        const price = card?.querySelector('[data-tier-price]');
        const compare = card?.querySelector('[data-tier-compare]');
        const unavailable = tierUnavailable(input, variant);

        if (price) price.textContent = formatMoney(values.total);
        if (compare) {
          compare.textContent = discount > 0 ? formatMoney(values.raw) : `${formatMoney(values.unit)} je ${singular}`;
        }
        input.disabled = unavailable;
        card?.classList.toggle('is-disabled', unavailable);
      });

      const checked = tierInputs.find((input) => input.checked && !input.disabled);
      if (!checked) {
        const fallback = tierInputs.find((input) => !input.disabled);
        if (fallback) fallback.checked = true;
      }
    }

    function renderSelection() {
      const variant = selectedVariant();
      if (!variant) return;

      refreshTierCards(variant);
      const selected = tierInputs.find((input) => input.checked && !input.disabled) || tierInputs.find((input) => !input.disabled);
      if (!selected) return;

      const quantity = Number(selected.value || 1);
      const discount = Number(selected.dataset.discount || 0);
      const values = calculate(Number(variant.price || 0), quantity, discount);
      const unit = quantity === 1 ? singular : plural;

      tierInputs.forEach((input) => input.closest('[data-lisado-tier]')?.classList.toggle('is-selected', input === selected));
      if (quantityInput) quantityInput.value = String(quantity);

      const summaryLabel = box.querySelector('[data-summary-label]');
      const summaryDiscount = box.querySelector('[data-summary-discount]');
      const summaryDiscountNote = box.querySelector('[data-summary-discount-note]');
      const summaryCompare = box.querySelector('[data-summary-compare]');
      const summaryTotal = box.querySelector('[data-summary-total]');
      const summaryUnit = box.querySelector('[data-summary-unit]');
      const summaryDay = box.querySelector('[data-summary-day]');
      const summaryBase = box.querySelector('[data-summary-base]');
      const summaryBaseWrap = box.querySelector('[data-summary-base-wrap]');
      const summaryBaseUnit = box.querySelector('[data-summary-base-unit]');
      const stickyTotal = sticky?.querySelector('[data-sticky-total]');
      const stickyCopy = sticky?.querySelector('[data-sticky-copy]');

      if (summaryLabel) summaryLabel.textContent = selected.dataset.label || `${quantity} ${unit}`;
      if (summaryDiscount) {
        summaryDiscount.hidden = discount === 0;
        summaryDiscount.textContent = discount > 0 ? `${discount}% Preisvorteil` : '';
      }
      if (summaryDiscountNote) summaryDiscountNote.hidden = discount === 0;
      if (summaryCompare) {
        summaryCompare.hidden = discount === 0;
        summaryCompare.textContent = discount > 0 ? formatMoney(values.raw) : '';
      }
      if (summaryTotal) summaryTotal.textContent = formatMoney(values.total);
      if (summaryUnit) summaryUnit.textContent = formatMoney(values.unit);
      if (summaryDay) summaryDay.textContent = formatMoney(values.day);
      if (summaryBase && summaryBaseWrap && summaryBaseUnit) {
        const baseUnitPrice = Number(variant.unit_price || 0);
        const baseSaving = Math.floor(baseUnitPrice * discount / 100);
        const baseDiscounted = baseUnitPrice - baseSaving;
        const referenceValue = Number(variant.unit_reference_value || 1);
        const referenceUnit = variant.unit_reference_unit || '';
        summaryBase.textContent = formatMoney(baseDiscounted);
        summaryBaseUnit.textContent = `/${referenceValue === 1 ? '' : referenceValue}${referenceUnit}`;
        summaryBaseWrap.hidden = !baseUnitPrice || !referenceUnit;
      }
      if (stickyTotal) stickyTotal.textContent = formatMoney(values.total);
      if (stickyCopy) stickyCopy.textContent = `${quantity} ${unit}`;

      if (primarySubmit && variant.available && !primarySubmit.disabled) {
        const label = primarySubmit.querySelector('span:not(.loading__spinner)');
        if (label) {
          label.textContent = ctaTemplate
            .replace('{quantity}', String(quantity))
            .replace('{unit}', unit);
        }
      }
    }

    tierInputs.forEach((input) => input.addEventListener('change', renderSelection));

    claimReferenceLink?.addEventListener('click', () => {
      const target = document.querySelector(claimReferenceLink.getAttribute('href'));
      const details = target?.closest('details');
      if (details) details.open = true;
    });

    box.addEventListener('change', (event) => {
      if (event.target.matches('product-form input[name="id"]')) {
        window.setTimeout(renderSelection, 0);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId === productInfo?.dataset.section) renderSelection();
      });
    }

    stickySubmit?.addEventListener('click', () => {
      if (form?.requestSubmit) form.requestSubmit();
      else primarySubmit?.click();
    });

    if (sticky && primarySubmit && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickySubmit) stickySubmit.tabIndex = show ? 0 : -1;
      }, { threshold: 0.05 });
      observer.observe(primarySubmit);
    }

    renderSelection();
  }

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
